import emailjs from 'emailjs-com'
import React, { useState } from 'react'
import { Link, animateScroll } from 'react-scroll'
import { Nav } from 'react-bootstrap'
import './Contactform.css'

const ContactForm = () => {
  const [submitted, setSubmitted] = useState(false)

  function sendEmail(e) {
    e.preventDefault()

    emailjs
      .sendForm(
        'service_drozb5u',
        'PortfolioWebsite',
        e.target,
        'user_59hiB9RHEexY65IYJr6Lx'
      )
      .then(
        (result) => {
          setSubmitted(true)
        },
        (error) => {
          setSubmitted(false)
        }
      )
    e.target.reset()
  }

  return (
    <div id="contact">
      <section data-aos="zoom-in-down" data-aos-easing="ease-in-sine">
        <h1 className="section-header">CONTACT</h1>
        <h5
          className="col-md-12 col-sm-6"
          style={{ textAlign: 'center', color: 'white' }}
        >
          Currently looking for any new opportunities. My inbox is always open.
          Whether you have a question or just want to say hi, I'll try my best
          to get back to you! You can also get connected with me via social
          media.
        </h5>

        <div className="contact-wrapper">
          <form className="form-horizontal" onSubmit={sendEmail}>
            <div className="form-group">
              <div className="col-sm-12">
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  placeholder="NAME"
                  name="name"
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <div className="col-sm-12">
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  placeholder="EMAIL"
                  name="email"
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <div className="col-sm-12">
                <input
                  type="text"
                  className="form-control"
                  id="subject"
                  placeholder="Subject"
                  name="subject"
                  required
                />
              </div>
            </div>

            <textarea
              className="form-control"
              rows="10"
              placeholder="MESSAGE"
              name="message"
              required
            ></textarea>
            {!submitted ? (
              <button
                className="btn btn-primary send-button"
                id="submit"
                type="submit"
                value="SEND"
              >
                <div className="button">
                  <i className="fa fa-paper-plane"></i>
                  <span className="send-text">SEND</span>
                </div>
              </button>
            ) : (
              <button className="btn btn-primary send-button" disabled>
                SENT
              </button>
            )}
          </form>
          {submitted ? (
            <div data-aos="zoom-out-down" data-aos-easing="ease-in-sine">
              <h3 style={{ color: 'white' }}>Thank you for your message.</h3>
              <button
                className="btn btn-primary"
                onClick={() => setSubmitted(false)}
              >
                Write another message?
              </button>
            </div>
          ) : (
            <button className="btn btn-primary" style={{ display: 'none' }}>
              Write another message?
            </button>
          )}

          <div className="direct-contact-container row align-items-center">
            <ul className="contact-list col-md-12 col">
              <li className="list-item">
                <i className="fa fa-map-marker fa-2x">
                  <span
                    className="contact-text place"
                    style={{ position: 'center' }}
                  >
                    Dhaka|Bangladesh
                  </span>
                </i>
              </li>

              <li className="list-item">
                <i className="fa fa-envelope fa-2x">
                  <span
                    className="contact-text gmail"
                    style={{ position: 'center', marginRight: '50px' }}
                  >
                    <a href="mailto:#" title="Send me an email">
                      mdirtiza.hossain1999@gmail.com
                    </a>
                  </span>
                </i>
              </li>
            </ul>
            <div>
              <hr />
              <ul className="social-media-list d-flex align-items-around">
                <li>
                  <a
                    href="https://github.com/irtiza1999"
                    target="_blank"
                    rel="noreferrer"
                    className="contact-icon"
                  >
                    <i className="fab fa-github" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/irtizahossain.ishad/"
                    target="_blank"
                    rel="noreferrer"
                    className="contact-icon"
                  >
                    <i className="fab fa-facebook"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/_doshai"
                    target="_blank"
                    rel="noreferrer"
                    className="contact-icon"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/in/md-irtiza-hossain-935a431ba"
                    target="_blank"
                    rel="noreferrer"
                    className="contact-icon"
                  >
                    <i className="fab fa-linkedin"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://discordapp.com/users/540140204909002752"
                    target="_blank"
                    rel="noreferrer"
                    className="contact-icon"
                  >
                    <i class="fab fa-discord"></i>
                  </a>
                </li>
              </ul>
              <footer style={{ textAlign: 'center', color: 'white' }}>
                <Link to="home" smooth={true} duration={800}>
                  <Nav.Link href="#home" className="navItem" eventKey="home">
                    <small onClick={() => animateScroll.scrollToTop()}>
                      Developed by Md. Irtiza Hossain.
                    </small>
                  </Nav.Link>
                </Link>
              </footer>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default ContactForm
